import type { StockPublicServiceDTO } from "@/server/integrations/stock-public/client";
import { config } from "@/shared/lib/config";
import { fetcher } from "@/shared/lib/fetcher";

export type { StockPublicServiceDTO };

export const stockPublicApi = {
  async list(params?: {
    q?: string;
    activeOnly?: boolean;
    categoryCode?: string;
    limit?: number;
  }): Promise<StockPublicServiceDTO[]> {
    const url = new URL(`${config.apiUrl}/stock-public/services`);
    if (params?.q) url.searchParams.set("q", params.q);
    if (params?.activeOnly === false) url.searchParams.set("activeOnly", "false");
    if (params?.categoryCode) {
      url.searchParams.set("categoryCode", params.categoryCode);
    }
    if (params?.limit != null) {
      url.searchParams.set("limit", String(params.limit));
    }
    return fetcher.get<StockPublicServiceDTO[]>(url.toString());
  },

  async get(code: string): Promise<StockPublicServiceDTO> {
    return fetcher.get<StockPublicServiceDTO>(
      `${config.apiUrl}/stock-public/services/${encodeURIComponent(code)}`,
    );
  },
};
